import { Observable } from "rxjs";
import { AuctionItem } from "../../models/auction-item";
import { StorageParameters } from "../storage.service";
import { ApiBase } from "./api.base";

export class BidsApi extends ApiBase {
  model = 'bids';

  public rollback(bidId: string): Observable<AuctionItem> {
    return this.http.post<AuctionItem>(
      this.buildUrl(bidId,'rollback'),
      undefined,
      {
        headers: this.setHeaders({
          'Authorization': this.getStorage().getItem(StorageParameters.AccessTokenId)
        })
      },
    )
  }

}
